import { render } from "./DepartmentSelector.vue?vue&type=template&id=20c628f0&scoped=true"
import script from "./DepartmentSelector.vue?vue&type=script&lang=js"
export * from "./DepartmentSelector.vue?vue&type=script&lang=js"

import "./DepartmentSelector.vue?vue&type=style&index=0&id=20c628f0&scoped=true&lang=css"

import exportComponent from "/Users/bertog/Code/aitmes/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20c628f0"]])

export default __exports__